const autoNgTemplateLoaderTemplate1 = require('./containerInstanceDetails.html');

import ContainerInstanceDetailsController from './containerInstanceDetailsController.js';

angular.module('portainer.azure').component('containerInstanceDetails', {
  templateUrl: autoNgTemplateLoaderTemplate1,
  controller: ContainerInstanceDetailsController,
});
